import { render } from "./CateCard.vue?vue&type=template&id=45a6be34&scoped=true"
import script from "./CateCard.vue?vue&type=script&lang=js"
export * from "./CateCard.vue?vue&type=script&lang=js"

import "./CateCard.vue?vue&type=style&index=0&id=45a6be34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a6be34"]])

export default __exports__